module.exports = __webpack_public_path__ + "static/img/Horizontal Frame 1,2m.e8dadbd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/Horizontal Frame 1,2m.jpg
// module id = 79
// module chunks = 1